import breakpointsList from '../../styles/variables/breakpoints.module.scss';
import initTabs from './tabs';

const populateSelectedFilterCount = (filterCountEl) => {
  const filterContainerElSelector = filterCountEl.dataset.locationListingFilterCount;
  const filterContainerEl = document.querySelector(filterContainerElSelector);
  if (!filterContainerEl) {
    return;
  }

  const count = filterContainerEl.querySelectorAll('input:checked').length;
  filterCountEl.textContent = count;

  if (count > 0) {
    filterCountEl.removeAttribute('hidden');
  } else {
    filterCountEl.setAttribute('hidden', '');
  }
};

const initFilterForm = (form, locationListingId) => {
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const formData = new FormData(form);
    const newPageUrl = getPathFromFormData({ formData });
    history.pushState(null, '', newPageUrl);

    formData.set('locationListingId', locationListingId);
    const apiUrl = `${document.location.origin}/wp-json/silvera_locations/v1/archive-location-list`;

    const formUrl = getPathFromFormData({
      formData,
      url: apiUrl,
    });

    let resultsEl = document.querySelector(`[data-location-results="${locationListingId}"]`);

    document.getElementById('archive-location')?.classList.add('pending');
    const submit = form.querySelector('[type="submit"]');
    submit.dataset.originalText = submit.textContent;
    submit.textContent = 'Searching...';
    submit.disabled = true;

    fetch(formUrl)
      .then((response) => response.json())
      .then((json) => {
        const node = new DOMParser().parseFromString(json.view, 'text/html');
        window.locations = json.locations;
        resultsEl.parentNode.replaceChild(node.body.firstChild, resultsEl);
        resultsEl = document.querySelector(`[data-location-results="${locationListingId}"]`);
        initTabs(resultsEl);
        if (typeof initGoogleMaps !== 'undefined') {
          initGoogleMaps(resultsEl);
        }
        document.getElementById('archive-location')?.classList.remove('pending');

        const filterCounts = document.querySelectorAll('[data-location-listing-filter-count]');
        filterCounts.forEach(populateSelectedFilterCount);

        submit.textContent = submit.dataset.originalText;
        submit.disabled = false;
        delete submit.dataset.originalText;

        if (document.getElementById('location-listing-results')) {
          window.scrollTo({
            top: document.getElementById('location-listing-results').offsetTop,
            left: 0,
            behavior: 'smooth',
          });
        }
      });
  });

  document.addEventListener('activatetab', (event) => {
    const tab = event.target.closest('[role="tab"]');
    const resultsEl = document.querySelector(`[data-location-results="${locationListingId}"]`);

    // Proced only if this is a location results tab.
    if (!resultsEl.contains(tab)) {
      return;
    }

    const showTab = tab.value;

    // update URL
    const url = new URL(document.location.href);
    url.searchParams.set('show_view', showTab);
    history.pushState(null, '', url);

    // update form
    form.show_view.value = showTab;
  });
};

const getPathFromFormData = ({ formData, url = document.location }) => {
  const urlParams = new URLSearchParams();
  for (let data of formData.entries()) {
      urlParams.append(data[0], data[1]);
  }

  let urlString = '';
  if (urlParams.toString()) {
      urlString += urlParams.toString();
  }

  if (document.location.hash) {
      urlString += document.location.hash;
  }

  return new URL(`?${urlString}`, url);
}

const initFilterForms = () => {
  const filterForms = Array.from(document.querySelectorAll("[data-location-filter-form]"));
  if (!filterForms.length) {
    return;
  }

  filterForms.forEach((form) => initFilterForm(form, form.dataset.locationFilterForm));
};

const initFilterContainerRespondToResize = () => {
  const locationListingFilterContainers = document.querySelectorAll('[data-location-listing-filter-container]');

  if (!locationListingFilterContainers) {
    return;
  }

  const locationListingRespond = (event) => {
    locationListingFilterContainers.forEach((container) => {
      if (window.matchMedia(`screen and (min-width: ${breakpointsList.tablet})`).matches) {
        container.style.removeProperty('max-height');
        container.removeAttribute('hidden');
      } else {
        container.setAttribute('hidden', '');
      }
    });
  };

  locationListingRespond();
  window.addEventListener('resize', locationListingRespond);
}

export default () => {
  initFilterForms();
  initFilterContainerRespondToResize();
};
